import { observer } from 'mobx-react-lite'
import { ComponentProps, FC, MouseEventHandler } from 'react'
import { styled } from '../../../lib/stitches'
import { IconButton } from '../../core/Components'
import { Randomize } from '../../core/icons'
import withTooltip from '../../core/withTooltip'

type RandomizeButtonProps = ComponentProps<typeof IconButton> & {
  randomize: () => void
}

const DiceIcon = styled(Randomize, { width: '17px', height: '17px' })

const IconButtonWithTooltip = withTooltip(IconButton)

const RandomizeButton: FC<RandomizeButtonProps> = observer(({ randomize, ...props }) => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.stopPropagation()
    randomize()
  }
  return (
    <IconButtonWithTooltip onClick={handleClick} {...props} tooltipText={'Randomize'}>
      {/* <img src="/static/icons/studio_magic_wand.svg" style={{ width: '15px', height: '15px' }} /> */}
      <DiceIcon />
    </IconButtonWithTooltip>
  )
})

export default RandomizeButton
